const usageActions = {
  FETCH_USAGE_REQUEST: 'USAGE_FETCH_REQUEST',
  FETCHING_USAGE: 'USAGE_FETCHING',
  FETCH_USAGE_SUCCESS: 'USAGE_FETCH_SUCCESS',
  FETCH_USAGE_ERROR: 'USAGE_FETCH_ERROR',

  FETCH_PROFESSIONAL_USAGE_REQUEST: 'USAGE_FETCH_PROFESSIONAL_REQUEST',
  FETCH_PROFESSIONAL_USAGE_SUCCESS: 'USAGE_FETCH_PROFESSIONAL_SUCCESS',

  FETCH_ENTITLEMENTS_REQUEST: 'USAGE_FETCH_ENTITLEMENTS_REQUEST',
  FETCHING_ENTITLEMENTS: 'USAGE_FETCHING_ENTITLEMENTS',
  FETCH_ENTITLEMENTS_SUCCESS: 'USAGE_FETCH_ENTITLEMENTS_SUCCESS',
  FETCH_ENTITLEMENTS_ERROR: 'USAGE_FETCH_ENTITLEMENTS_ERROR',

  FETCH_ACCOUNTS_REQUEST: 'USAGE_FETCH_ACCOUNTS_REQUEST',
  FETCHING_ACCOUNTS: 'USAGE_FETCHING_ACCOUNTS',
  FETCH_ACCOUNTS_SUCCESS: 'USAGE_FETCH_ACCOUNTS_SUCCESS',
  FETCH_ACCOUNTS_ERROR: 'USAGE_FETCH_ACCOUNTS_ERROR',

  FETCHING_ACCOUNT_APPOINTMENTS: 'USAGE_FETCHING_ACCOUNT_APPOINTMENTS',
  FETCH_ACCOUNT_APPOINTMENTS_SUCCESS: 'USAGE_FETCH_ACCOUNT_APPOINTMENTS_SUCCESS',
  FETCH_ACCOUNT_APPOINTMENTS_ERROR: 'USAGE_FETCH_ACCOUNT_APPOINTMENTS_ERROR',
  FETCH_ACCOUNT_APPOINTMENTS_DONE: 'USAGE_FETCH_ACCOUNT_APPOINTMENTS_DONE',

  fetchUsage: () => ({
    type: usageActions.FETCH_USAGE_REQUEST,
  }),
  fetchProfessionalUsage: (professionalUid) => ({
    type: usageActions.FETCH_PROFESSIONAL_USAGE_REQUEST,
    payload: professionalUid,
  }),
  fetchEntitlements: () => ({
    type: usageActions.FETCH_ENTITLEMENTS_REQUEST,
  }),
  // Contas criadas no intervalo (ms) com o último acesso lido do Firebase Auth.
  fetchAccounts: ({ since, until }) => ({
    type: usageActions.FETCH_ACCOUNTS_REQUEST,
    payload: { since, until },
  }),
};

export default usageActions;
